/* EmojiFallback.tsx generated by @compiled/babel-plugin v0.36.1 */
import _extends from "@babel/runtime/helpers/extends";
import "./EmojiFallback.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import { EmojiNodeWrapper } from './Emoji';
import { emojiNodeStyles, commonSelectedStyles, selectOnHoverStyles } from './styles';
var emojiFallbackStyles = null;
export var EmojiFallback = function EmojiFallback(props) {
  var emoji = props.emoji,
    selected = props.selected,
    selectOnHover = props.selectOnHover,
    className = props.className;
  var fallback = emoji.fallback,
    shortName = emoji.shortName;
  var classes = "".concat(emojiNodeStyles, " ").concat(selected ? commonSelectedStyles : '', " ").concat(selectOnHover ? selectOnHoverStyles : '', " ").concat(className ? className : '');
  return (
    /*#__PURE__*/
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    React.createElement(EmojiNodeWrapper, _extends({
      type: "image"
    }, props, {
      className: classes
    }), /*#__PURE__*/React.createElement("span", {
      className: ax(["_1reo15vq _18m915vq _1e0c1txw _1bsb1osq _4t3i1osq _1bah1h6o _4cvr1h6o"])
    }, fallback || shortName))
  );
};
export default EmojiFallback;